import React, { useMemo, useState } from 'react'
import BigNumber from 'bignumber.js/bignumber'
import { useWeb3React } from '@web3-react/core/core/core'
import styled, { DefaultTheme, keyframes, css } from "styled-components";
import { useFetchPublicPoolsData, usePools, useFetchCakeVault, useCakeVault } from 'state/poolsDrop4/hooks'
import { Modal, Text, Flex, Button, HelpIcon, AutoRenewIcon, Box , Card, Heading, Skeleton, VerifiedIcon} from '@pancakeswap/uikit'
import { getBalanceNumber } from 'utils/formatBalance'
import { useCakeVaultContract6 } from 'hooks/useContract3'
import useTheme from 'hooks/useTheme'
import useToast from 'hooks/useToast'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Balance from 'components/Balance'
import {  usePriceCakeBusd } from 'state/farms/hooks22'
import { getbvcAddress, getCakeAddress, getlgcAddress } from 'utils/addressHelpers'
import { useFaucet, useFaucet2, useFaucet4 } from 'hooks/useTokenBalance'
import getTimePeriods from 'utils/getTimePeriods'
import useWithdrawalFeeTimer from 'views/Donation/hooks/useWithdrawalFeeTimer'

interface BountyModalProps {
  onDismiss?: () => void
}
const RainbowLight = keyframes`
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
`;
const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundDisabled};
  height: 1px;
  margin: 16px auto;
  width: 100%;
`
const ImageWrapper = styled.div`
margin: 0 auto;
margin-right: 5px;

${({ theme }) => theme.mediaQueries.md} {

  margin: 0 auto;
  margin-right: 5px;
}
`
const StyledModalContainer = styled(Box)`
  max-width: 1200px;
  width: 100%;
  border-radius: 25px;
  

  ${({ theme }) => theme.mediaQueries.md} {
    max-width: 1200px;
    width: 100%;

    border-radius: 25px;
`
const StyledModalContainer2 = styled(Card)`
  width: 100%;
  max-width: 250px;
  min-width: 250px;
  background-color: rgba(0,0,0);

  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
    max-width: 250px;
    min-width: 250px;
    background-color: rgba(0,0,0);
    

`
const StyledModalContainer4 = styled(Card)`
  width: 100%;
  min-width: 228px;
  max-width: 228px;
  background-color: rgba(0,0,0);
}
  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
    max-width: 228px;
    min-width: 228px;
    background-color: rgba(0,0,0);

`
const StyledModalContainer5 = styled(Card)`
  min-width: 228px;
  max-width: 228px;
  width: 100%;
  background-color: rgba(0,0,0);
  background: linear-gradient(
    45deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  );
  background-size: 300% 300%;
  opacity: 100%;
  animation: ${RainbowLight} 2s linear infinite;
}
  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
    max-width: 228px;
    background: linear-gradient(
      45deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(255, 154, 0, 1) 10%,
      rgba(208, 222, 33, 1) 20%,
      rgba(79, 220, 74, 1) 30%,
      rgba(63, 218, 216, 1) 40%,
      rgba(47, 201, 226, 1) 50%,
      rgba(28, 127, 238, 1) 60%,
      rgba(95, 21, 242, 1) 70%,
      rgba(186, 12, 248, 1) 80%,
      rgba(251, 7, 217, 1) 90%,
      rgba(255, 0, 0, 1) 100%
    );
    background-size: 300% 300%;
    animation: ${RainbowLight} 2s linear infinite;
    min-width: 228px;
    background-color: rgba(0,0,0);
    opacity: 100%;
    animation: ${RainbowLight} 3s linear infinite;

`
const StyledModalContainer3 = styled(Card)`
  max-width: 250px;
  width: 100%;
  min-width: 250px;
  background-color: rgba(0,0,0);
  border-radius: 25px;
  ${({ theme }) => theme.mediaQueries.md} {
    max-width: 250px;
    width: 100%;
    min-width: 250px;
    background-color: rgba(0,0,0);
    border-radius: 25px;
  }
`
const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`
const BountyCard2:  React.FC = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { theme } = useTheme()
  const { toastError, toastSuccess } = useToast()
  const cakeVaultContract = useCakeVaultContract6()
  const [pendingTx, setPendingTx] = useState(false)
  const {
    estimatedCakeBountyReward,
    totalPendingCakeHarvest,
    userData: { lastDepositedTime },
    fees: { callFee },
  } = useCakeVault()
   const nem =  parseInt(lastDepositedTime)
  

  const cakePriceBusd = usePriceCakeBusd()
  const callFeeAsDecimal = callFee / 100
  const FULL3 = getBalanceNumber(useFaucet4(getbvcAddress()))
  const FULL4 = FULL3 / 1000
  const totalYieldToDisplay = getBalanceNumber(totalPendingCakeHarvest, 18)
  const { pools: poolsWithoutAutoVault, userDataLoaded } = usePools(account)
  const pools = useMemo(() => {
    const cakePool = poolsWithoutAutoVault.find((pool) => pool.sousId === 0)
    const cakeAutoVault = { ...cakePool, isAutoVault: true }
    return [cakeAutoVault, ...poolsWithoutAutoVault]
  }, [poolsWithoutAutoVault])
  useFetchCakeVault()
  useFetchPublicPoolsData()
  const estimatedDollarBountyReward = useMemo(() => {
    return new BigNumber(estimatedCakeBountyReward).multipliedBy(cakePriceBusd)
  }, [cakePriceBusd, estimatedCakeBountyReward])

  const hasFetchedDollarBounty = estimatedDollarBountyReward.gte(0)
  const hasFetchedCakeBounty = estimatedCakeBountyReward ? estimatedCakeBountyReward.gte(0) : false
  const dollarBountyToDisplay = hasFetchedDollarBounty ? getBalanceNumber(estimatedDollarBountyReward, 18) : 0
  const cakeBountyToDisplay = hasFetchedCakeBounty ? getBalanceNumber(estimatedCakeBountyReward, 18) : 0
 
  const shouldShowTimer = account && lastDepositedTime
  const goo = shouldShowTimer 
  const goo0 = parseInt(goo)
  const goo3 = goo0
  const currentTimestamp = () => new Date().getTime()
  const anyad  = currentTimestamp()
  const anyad2 = anyad / 1000
  const goo2 = goo3 - anyad2
  const { months,days, hours, minutes } = getTimePeriods(goo2)
  const getRowText = () => {
    if ( goo2 > 0) {
          return   <Text bold fontSize="14px" >{t('%day%d : %hour%h : %minute%m', { day: days, hour: hours, minute: minutes })}</Text>
    }
    if ( goo2 < 0) {
      return   <Text textAlign="left" fontSize="14px" bold color='contrast' >   
      {t('NOW')}
       </Text>
    }
    return <Text bold fontSize="14px">{t('%day%d : %hour%h : %minute%m', { day: days, hour: hours, minute: minutes })}</Text>
  }
  const handleConfirmClick = async () => {
    setPendingTx(true)
    try {
      const tx = await cakeVaultContract.harvest()
      const receipt = await tx.wait()
      if (receipt.status) {
        toastSuccess(t('Bounty collected!'), t('VIZSLASWAP bounty has been sent to your wallet.'))
        setPendingTx(false)
      }
    } catch (error) {
      toastError(t('Error'), t('Please try again. Confirm the transaction and make sure you are paying enough gas!'))
      setPendingTx(false)
    }
  }

  return (
    <StyledModalContainer>
      <Flex alignItems="center" justifyContent="center">
      <StyledModalContainer5>
      <StyledModalContainer4>
      <Flex flex="1" flexDirection="column"  mt="-10px"  mb="10px"  mr="10px" ml="10px">
      <Flex alignItems="center" mt="20px"  justifyContent="center" >
         <Text color="isten" bold fontSize="14px" mr="4px">
              {t('Token:')}
            </Text>
            <Text color="text" bold fontSize="14px" mr="4px">
              {t('BVC')}
            </Text>

            </Flex>
      <Flex alignItems="center" justifyContent="center" >
        
         <Text color="isten" bold fontSize="14px">
              {t('Remaining:')}
            </Text>
            <Balance
              bold
              ml="4px"
              fontSize="14px"
              decimals={0}
              unit=" Users"
              prefix="for "
              value={FULL4}
            />

            </Flex>
            <Flex alignItems="center" justifyContent="center"  mb="5px">
            <Text color="isten" bold fontSize="14px" mr="4px">
              {t('Claim again:')}
            </Text>
            <Text  color="text" fontSize='14px' ml="4px" >
          {getRowText()}
            </Text>
             </Flex>
             <Flex alignItems="center" justifyContent="space-between" ml="40px" mr="40px"  >
        <ImageWrapper>
        <img src="/images/pixel/003.png" alt="ifo bunny" width="100%" height="100%"/>
      </ImageWrapper>
      </Flex>
      {account ? (
        <Button
          isLoading={pendingTx}
          endIcon={pendingTx ? <AutoRenewIcon spin color="currentColor" /> : null}
          onClick={handleConfirmClick}
          id="autoCakeConfirmBounty"
          width="100%"
          disabled={FULL3 < 0  || goo2 > 0}
          variant="secondary"
        >
             <ButtonText color="primary" bold fontSize="14px">
             <Flex alignItems="center" justifyContent="space-between"  >
             {pendingTx ? t('Claiming') : t('Claim')}
             <Text color="primary" bold fontSize="14px" ml="4px">
              {t('1,000 BVC')}
            </Text>
                </Flex>
         </ButtonText>
        </Button>
      ) : (
        <ConnectWalletButton width="100%"/>
      )}
               
               </Flex>

          </StyledModalContainer4>
          </StyledModalContainer5>
          </Flex>
    </StyledModalContainer>
  )
}

export default BountyCard2
